import { FunctionComponent } from 'react'
import styles from './deleteAdminDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { DELETE_TRUSTEE } from '@/modules/API/daycareGroup/trusteeLinkHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface DeleteAdminDialogProps {
    open: boolean
    handleClose: () => void
    trusteeId: number
    refetchGroups: () => void
}

const DeleteAdminDialog: FunctionComponent<DeleteAdminDialogProps> = ({
    open,
    handleClose,
    trusteeId,
    refetchGroups
}: DeleteAdminDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteTrustee] = useMutation(DELETE_TRUSTEE, {
        variables: {
            trusteeId: trusteeId
        },
        onCompleted: () => {
            showNotificationSuccess(t('adminDeleted'))

            refetchGroups()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedAdmin'))

            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteAdmin')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteAdminMessage')}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteTrustee}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteAdminDialog
